import { c } from '@debbie/cortex/dist/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '../index.js';
import CodeInput from './CodeInput.js';
const CODE_LENGTH = 6;
const TwoFactor = (props) => {
    const lang = useSelector((s) => s.lang);
    const [token, setToken] = useState('');
    const verify = (code) => {
        c.auth.verifyTwoFactor(props.username, props.password, code);
    };
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                verify(token);
            } },
            React.createElement("p", null, lang.login.twoFactorExplainer),
            React.createElement(CodeInput, { value: token, onChange: setToken, onComplete: verify, length: CODE_LENGTH, autoFocus: true, label: lang.login.twoFactorPlaceholder }),
            React.createElement(Button, { block: true, disabled: token.length !== CODE_LENGTH, style: { marginBottom: '10px' } }, lang.misc.approve))));
};
export default TwoFactor;
//# sourceMappingURL=TwoFactor.js.map